import React from 'react'
import { Col, Row } from 'antd'
import { formatDateTime, getSupplierOrderStatus } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { InfoItem } from 'Pages/Merchants/components'
import { SupplierOrderData } from 'Store/supplier-order/types'
import { StatusTag } from 'Components/utilities'

type Props = {
  detail?: SupplierOrderData
}

const SupplierOrderInfo: React.FunctionComponent<Props> = props => {
  const { detail } = props

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderStatus = (status: string) => {
    const statusResult = getSupplierOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  return (
    <BoxWrapper>
      <Row>
        <Col md={12} xs={24}>
          <BoxTitle>รายละเอียดการสั่งซื้อ</BoxTitle>
          {renderInfo('เลขที่สั่งซื้อ', detail?.sale_order_no || '')}
          {renderInfo('วันที่สั่งซื้อ', formatDateTime(detail?.created_at || ''))}
          {renderInfo('เลขที่ใบเสนอราคา', detail?.quotation_no || '')}
          {renderInfo('ผู้ออกใบเสนอราคา', detail?.issuer_name)}
        </Col>
        <Col md={12} xs={24}>
          <BoxTitle> &nbsp;</BoxTitle>
          {renderInfo('สถานะคำสั่งซื้อ', renderStatus(detail?.status || ''))}
          {renderInfo('หมายเหตุ', detail?.reason)}
          {detail?.delivered_dt &&
            renderInfo('วันที่จัดส่งสำเร็จ', formatDateTime(detail?.delivered_dt || ''))}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

export default SupplierOrderInfo
